"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedMessage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _translationsNamespaceContext = require("../contexts/TranslationsNamespaceProvider/translationsNamespaceContext");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Props for the FormattedMessage component.
 *
 * @template T - The type of translations.
 * @template V - The type of values for message formatting.
 */

/**
 * Renders a formatted internationalized message using the provided translation data.
 * @remarks Use in case of translation with HTML components instead of formatMessage accessible from useTranslations hook
 *
 * @template T The type of the translation data.
 *
 * @example
 * // Basic usage
 * <FormattedMessage<DefaultTranslations> id="greeting" />
 *
 * @description
 * This component is used for rendering internationalized messages. It combines the provided `id` with
 * the current translation namespace to retrieve the corresponding translation message.
 *
 * @see {@link FormattedMessageProps} for the available props and options.
 */
const FormattedMessage = ({
  id,
  ...props
}) => {
  const {
    namespace
  } = (0, _react.useContext)(_translationsNamespaceContext.translationsNamespaceContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
    id: `${namespace}:${String(id)}`,
    ...props
  });
};
exports.FormattedMessage = FormattedMessage;
//# sourceMappingURL=FormattedMessage.js.map